// generate=ts:EventTypeEnums
/** Valid session event types */
export var SessionEventType;
(function (SessionEventType) {
    /** Match all session event types */
    SessionEventType["all"] = "session.*";
    /** Notification that a session has been created */
    SessionEventType["created"] = "session.created";
    /** Notification that a session has been deleted */
    SessionEventType["deleted"] = "session.deleted";
})(SessionEventType || (SessionEventType = {}));
//# sourceMappingURL=session-events.js.map